module.exports = __webpack_public_path__ + "img/deleteComment.4b54e252.svg";